import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PaymentsHistoryResponse } from "../../../types/rtk/paymentsHistory/paymentsHistory";
import Title from "../../atoms/Title/Title";
import Text from "../../atoms/Text/Text";
import PaymentHistoryCard from "../../molecules/PaymentHistoryCard/PaymentHistoryCard";


interface Props {
  data : PaymentsHistoryResponse;
}

const PaymentHistoryList = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <Box className="PaymentsHistoryList">
      <Box className="paymentsHistoryListSubtitleContainer">
        <Title
          variant="h1"
          className="paymentsHistoryListTitle"
          children={t("subscription:PAYMENTS_LIST.TITLE")}
        />
        <Text
          className="paymentsHistoryListTextSubtitle"
          children={t("subscription:PAYMENTS_LIST.SUBTITLE")}
        />
      </Box>

      {data.payments.length === 0 ? (
        <Text
          className="paymentHistoryListNoDefault"
          children={t("subscription:PAYMENTS_LIST.NO_PAYMENTS.TITLE")}
        />
      ) : (
        data.payments.map((payment) => (
          <PaymentHistoryCard
            key={payment.id}
            data={payment}
          />
        ))
      )}
    </Box>
  );
};

export default PaymentHistoryList;